import styled, { css } from "styled-components";

import { BadgeProps } from "./Badge";
import { FontStyle } from "../FontStyle";

export const StyledBadge = styled.div<Partial<BadgeProps>>`
  ${FontStyle}
  align-items: center;
  background-color: ${(props) =>
    !props.backgroundColor ? "var(--color-primary)" : props.backgroundColor};
  border: ${(props) =>
    props.isStandalone ? "none" : "2px solid var(--page-paper-main)"};
  block-size: ${(props) => props.dimension + "px"};
  border-radius: 100%;
  color: var(--color-theme-100);
  display: flex;
  font-size: 10px;
  font-weight: 500;
  inline-size: ${(props) => props.dimension + "px"};
  justify-content: center;
  padding: ${(props) =>
    props.value && (props.value > 99 ? "4px" : props.value < 100 && "2px")};
  pointer-events: none;
  position: absolute;
  z-index: 1;

  ${({ isStandalone }) =>
    isStandalone &&
    css`
      position: static;
      z-index: 0;
    `}

  ${({ position }) =>
    position === "top-left" &&
    css`
      inset-block-start: 0;
      inset-inline-start: 0;
    `}

  ${({ position }) =>
    position === "top-right" &&
    css`
      inset-block-start: 0;
      inset-inline-end: 0;
    `}

    ${({ position }) =>
    position === "bottom-right" &&
    css`
      inset-block-end: 0;
      inset-inline-end: 0;
    `}

    ${({ position }) =>
    position === "bottom-left" &&
    css`
      inset-block-end: 0;
      inset-inline-start: 0;
    `}
`;
